import * as React from "react"

import {
  SidebarInset,
  SidebarProvider,
} from "@/components/ui/sidebar"
import { PortalSidebar } from "./sidebar"

export const AppSidebar = ({
  children,
}: {
  children?: React.ReactNode
}) => {
  return (
    <SidebarProvider defaultOpen={false}>
      <PortalSidebar />
      <SidebarInset className="flex data-[state=open]:bg-red-500">
        {children}
      </SidebarInset>
    </SidebarProvider>
  )
}
